import { useEffect, useState } from "react";
import { Empty, Pagination } from "antd";
import axiosLLInstance from "../../utils/axiosLLInstance";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { SET_SELECTED_DEVICE } from "../../redux/actions/dashboardActions";
import { signalTypeByRssi } from "../../utils/signalType";
import Td from "../common/Td";
import { PageSizeOptions, Role } from "../../utils/constants";
const columns = [
  "Model",
  "IMEI",
  "Status",
  "Network Strength",
  "Network Type",
  "SIM Operator",
  "Updated At",
];

export default function AdminDevicesList({ fleetId, userId }) {
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(PageSizeOptions.pageSize);
  const [data, setData] = useState({
    devices: [],
    total: 0,
  });
  const [filteredDevices, setFilteredDevices] = useState({
    devices: [],
    total: 0,
  });
  const role = useSelector((state) => state.auth.role);

  const navigate = useNavigate();
  const dispatch = useDispatch();

  useEffect(() => {
    getFleetDevices(currentPage, pageSize);
  }, [currentPage, pageSize]);

  const getFleetDevices = (page = 1, limit = PageSizeOptions.pageSize) => {
    const url = userId
      ? `/devices/fleets/${fleetId}/users/${userId}`
      : `/devices/fleets/${fleetId}`;

    axiosLLInstance
      .get(url, {
        params: {
          page: page,
          limit: limit,
        },
      })
      .then(({ data }) => {
        const temp = { devices: [], total: 0 };
        temp.total = data.total;
        data.devices.forEach((device) => {
          const { imei, presence, rssi, net_t, op } = device;
          const online = presence === "Online";
          temp.devices.push({
            ...device,
            rssi: online ? signalTypeByRssi(rssi) : "-",
            net_t: online ? net_t : "-",
            op: online ? op : "-",
            id: imei,
          });
        });
        setData(temp);
        setFilteredDevices(temp);
      })
      .catch((err) => console.error("Error fetching devices", err));
  };

  const onPageChange = (page) => {
    setCurrentPage(page);
  };

  const onSizeChange = (current, size) => {
    setPageSize(size);
    setCurrentPage(current);
  };
  const handleClick = (device) => {
    dispatch(SET_SELECTED_DEVICE(device));
    if (role === Role.SUPERADMIN) {
      navigate(`/dashboard/devices-analytics/${device.imei}`);
    } else {
      navigate(`/devices-analytics/${device.imei}`);
    }
  };

  return (
    <>
      <div className="overflow-x-auto mt-6">
        <table className="table">
          <thead className="border-b-2 border-base-300">
            <tr className="text-[#B1B1B1] text-[15px] font-[700] leading-[35px]">
              {columns.map((column) => (
                <th key={column}>{column}</th>
              ))}
            </tr>
          </thead>
          <tbody className="mt-3">
            {filteredDevices.devices?.length ? (
              <>
                {filteredDevices.devices.map((device) => {
                  return (
                    <tr
                      onClick={() => handleClick(device)}
                      key={device.imei}
                      className="shadow-[0_3.5px_5.5px_0_#00000005] h-16 cursor-pointer"
                    >
                      <Td className={"rounded-l-[15px]"}>
                        {" "}
                        {device.mdl_id || "-"}
                      </Td>
                      <Td> {device.imei}</Td>
                      <Td
                        className={`${
                          device.presence === "Online"
                            ? "text-green-500"
                            : "text-red-500"
                        }`}
                      >
                        {device.presence || "-"}
                      </Td>
                      <Td>
                        {device.presence === "Online"
                          ? signalTypeByRssi(device.rssi)
                          : "-"}
                      </Td>
                      <Td>
                        {device.presence === "Online" ? device.net_t : "-"}
                      </Td>
                      <Td>{device.presence === "Online" ? device.op : "-"}</Td>
                      <Td className={"rounded-r-[15px]"}>
                        {" "}
                        {device.updated_at
                          ? new Date(device.updated_at).toLocaleString(
                              "en-GB",
                              {
                                day: "2-digit",
                                month: "2-digit",
                                year: "numeric",
                                hour: "2-digit",
                                minute: "2-digit",
                                second: "2-digit",
                                hour12: false,
                              }
                            )
                          : "-"}
                      </Td>
                    </tr>
                  );
                })}
              </>
            ) : (
              <tr>
                <td colSpan={columns.length}>
                  <div className="flex justify-center items-center h-[200px]">
                    <Empty description="No Devices Found" />
                  </div>
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
      {filteredDevices.total > 0 && (
        <div className="flex justify-end mt-4 w-[100%]">
          <Pagination
            current={currentPage}
            total={filteredDevices.total}
            pageSize={pageSize}
            onChange={onPageChange}
            showSizeChanger={true}
            onShowSizeChange={onSizeChange}
            pageSizeOptions={PageSizeOptions.options}
          />
        </div>
      )}
    </>
  );
}
